import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DebitPayment from '../PaymentMethodsPage/DebitPayment'
import {
  getPaymentMethods,
  selectPaymentMethod,
} from '../../../../store/actions/pay-apply-actions'
import { getText } from '../../../../internal/TextLabels'
import { PayApplyType } from '../../../../models/payapply'

const DebitOnDone = props => {
  const [debitAmount, setDebitAmount] = useState(0)
  const [debitReference, setDebitReference] = useState('')
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({})
  const [isCardNotDebitable, setIsCardNotDebitable] = useState(false)
  const [selectedCard, setSelectedCard] = useState(
    props.payApply.current.selectedPaymentMethod &&
      props.payApply.current.selectedPaymentMethod.availableCards &&
      props.payApply.current.selectedPaymentMethod.availableCards.length
      ? props.payApply.current.selectedPaymentMethod.availableCards[0]
      : {},
  )

  const [debitPaymentChecked, setDebitPaymentChecked] = useState(false)
  const [isValidDebitAmount, setIsValidDebitAmount] = useState(false)
  const [disableDebit, setDisableDebit] = useState(true)

  const approvedAccountNumber = useRef(
    props.payApply.application && props.payApply.application.applicationResult
      ? props.payApply.application.applicationResult.account.accountNumber
      : '',
  )

  // Hack for ie timing issue
  const didCallGetPaymentMethods = useRef(false)

  const [returnObject, setReturnObject] = useState({
    selectedCard,
    debitAmount,
    debitReference,
    selectedPaymentMethod,
  })

  const collectReturnData = () => {
    setReturnObject({
      selectedCard,
      debitAmount,
      debitReference,
      selectedPaymentMethod,
      type: PayApplyType.PAYMENT,
      formSpecData: props.payApply.formSpec.formValues || {
        'applicant-government-id': props.payApply.current.governmentId,
        'applicant-mobile-number': props.payApply.addressInfo.mobilePhoneNumber
          ? props.payApply.addressInfo.mobilePhoneNumber.value
          : '',
        'applicant-email-address': props.payApply.addressInfo.email,
      },
    })
  }

  useEffect(() => {
    if (!didCallGetPaymentMethods.current) {
      props.getPaymentMethods(
        props.payApply.current.governmentId,
        props.payApply.wizard.wizard,
      )
      didCallGetPaymentMethods.current = true
    }
  })

  useEffect(() => {
    if (props.payApply.paymentMethods && props.payApply.paymentMethods.length) {
      const _paymentMethod = props.payApply.paymentMethods.find(
        pm =>
          pm.accounts &&
          !!pm.accounts.filter(
            account => account.accountNumber === approvedAccountNumber.current,
          ).length,
      )

      if (_paymentMethod) {
        setSelectedPaymentMethod(_paymentMethod)
        if (
          _paymentMethod.availableCards &&
          _paymentMethod.availableCards.length
        ) {
          setSelectedCard(_paymentMethod.availableCards[0])
        } else {
          setDisableDebit(false)
        }
      }
    }
  }, [props.payApply.paymentMethods])

  useEffect(() => {
    props.onDebitOpen(debitPaymentChecked)
  }, [debitPaymentChecked])

  useEffect(() => {
    props.onValidAmount(isValidDebitAmount)
  }, [isValidDebitAmount])

  useEffect(() => {
    collectReturnData()
  }, [selectedCard, debitAmount, debitReference, selectedPaymentMethod])

  useEffect(() => {
    setIsCardNotDebitable(
      (selectedCard.cardNumber &&
        selectedCard.cardNumber.toUpperCase().includes('X')) ||
        !selectedCard.allowPaymentWithoutCard,
    )
  }, [selectedCard])

  useEffect(() => {
    props.onChange(returnObject)
  }, [returnObject])

  useEffect(() => {
    setDisableDebit(isCardNotDebitable)
  }, [isCardNotDebitable])

  return (
    !props.debitDisabled && (
      <div
        style={{
          marginTop: '2rem',
          padding: '2rem',
          border: '1px solid lightgrey',
          minHeight: '90px',
        }}
      >
        <DebitPayment
          disabled={disableDebit}
          debitPaymentChecked={debitPaymentChecked}
          isValid={validation => {
            setIsValidDebitAmount(validation.valid)
          }}
          onDebitPaymentSwitch={checked => {
            setDebitPaymentChecked(checked)
          }}
          onChangeAmount={newAmount => setDebitAmount(newAmount)}
          debitReference={debitReference}
          onChangeDebitReference={ref => setDebitReference(ref)}
          minPurchaseLimit={
            selectedPaymentMethod ? selectedPaymentMethod.minPurchaseLimit : 0
          }
          maxPurchaseLimit={
            selectedCard.usableAmount
              ? selectedCard.usableAmount
              : selectedPaymentMethod?.maxLimit
          }
          selectedCard={selectedCard}
          availableCards={selectedCard.availableCards}
          onChangeCard={cardNumber => setSelectedCard(cardNumber)}
          selectedPaymentMethod={selectedPaymentMethod}
          debitUnavailableReason={
            (disableDebit &&
              false &&
              getText('payApply.paymentMethod.debitInTerminalRequired')) ||
            ''
          }
        />
      </div>
    )
  )
}

DebitOnDone.propTypes = {
  payApply: PropTypes.object.isRequired,
  debitDisabled: PropTypes.bool.isRequired,
  getPaymentMethods: PropTypes.func.isRequired,
  onDebitOpen: PropTypes.func,
  onValidAmount: PropTypes.func,
  onChange: PropTypes.func,
}

DebitOnDone.defaultProps = {
  onDebitOpen: () => {},
  onValidAmount: () => {},
  onChange: () => {},
}

const mapStateToProps = state => {
  return {
    payApply: state.payApply,
    debitDisabled: state.storeInfo.debitDisabled,
  }
}

const mapDispatchToProps = dispatch => ({
  getPaymentMethods: (governmentId, customerType) => {
    dispatch(getPaymentMethods({ governmentId, customerType }, false, false))
  },
  selectPaymentMethod: paymentMethod => {
    dispatch(selectPaymentMethod(paymentMethod))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DebitOnDone)
